export const SET_SIDEBAR_TRANSACTIONS_COUNT = 'SET_SIDEBAR_TRANSACTIONS_COUNT';
export const SET_REIMBURSABLE_EXPENSES_COUNT = 'SET_REIMBURSABLE_EXPENSES_COUNT';
export const SET_CARD_REQUESTS_COUNT = 'SET_CARD_REQUESTS_COUNT';
export const SET_READY_TO_PAY_BILLS_COUNT = 'SET_READY_TO_PAY_BILLS_COUNT';
export const SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT = 'SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT';
export const SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT = 'SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT';
export const SET_RECEIPTS_COUNT = 'SET_RECEIPTS_COUNT';
export const SET_RECURRING_SPEND_SUGGESTIONS_COUNT = 'SET_RECURRING_SPEND_SUGGESTIONS_COUNT';
export const SET_ACCOUNTING_PAGE_COUNT = 'SET_ACCOUNTING_PAGE_COUNT';
export const SET_SIDEBAR_DELEGATE_TRANSACTIONS_COUNT = 'SET_SIDEBAR_DELEGATE_TRANSACTIONS_COUNT';
export const SET_SIDEBAR_DELEGATE_REIMBURSABLE_EXPENSES_COUNT = 'SET_SIDEBAR_DELEGATE_REIMBURSABLE_EXPENSES_COUNT';

export class SetSidebarTransactionsCount {
  readonly type = SET_SIDEBAR_TRANSACTIONS_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetCardRequestsCount {
  readonly type = SET_CARD_REQUESTS_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetReimbursableExpensesCount {
  readonly type = SET_REIMBURSABLE_EXPENSES_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetPersonalReimbursableExpensesCount {
  readonly type = SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetSidebarPersonalTransactionsCount {
  readonly type = SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetReceiptsCount {
  readonly type = SET_RECEIPTS_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetReadytoPayBillsCount {
  readonly type = SET_READY_TO_PAY_BILLS_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetAccountingPageCount {
  readonly type = SET_ACCOUNTING_PAGE_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetRecurringSpendSuggestionsCount {
  readonly type = SET_RECURRING_SPEND_SUGGESTIONS_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetSidebarDelegateTransactionsCount {
  readonly type = SET_SIDEBAR_DELEGATE_TRANSACTIONS_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export class SetSidebarDelegateReimbursableExpensesCount {
  readonly type = SET_SIDEBAR_DELEGATE_REIMBURSABLE_EXPENSES_COUNT;
  readonly payload: number;
  constructor(public count: number) {
    this.payload = count;
  }
}

export type SidebarCountersAction =
  | SetSidebarTransactionsCount
  | SetCardRequestsCount
  | SetReimbursableExpensesCount
  | SetPersonalReimbursableExpensesCount
  | SetSidebarPersonalTransactionsCount
  | SetReceiptsCount
  | SetReadytoPayBillsCount
  | SetRecurringSpendSuggestionsCount
  | SetAccountingPageCount
  | SetSidebarDelegateTransactionsCount
  | SetSidebarDelegateReimbursableExpensesCount;
